module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/main-e15a96f102d278436ace1df9bcc31ece.jpg";